module.exports = __webpack_public_path__ + "static/media/caudalnegrop75.852a92fc.gif";